import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const LoadMoreIndicator = ({ isLoading, hasMore }) => {
  if (!hasMore && !isLoading) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 1.5,
        gap: 1,
      }}
    >
      {isLoading ? (
        <CircularProgress size={18} />
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'text.secondary',
          }}
        >
          <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
          <Typography variant="caption" sx={{ fontSize: '0.72rem' }}>
            Scroll up to load older messages
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LoadMoreIndicator;
